import { hexToCSSFilter } from 'hex-to-css-filter';
import { HTMLAttributes, MouseEventHandler } from 'react';

interface Props {
  svg: string;
  alt: string;
  pxSize?: number;
  padding?: string;
  hexColor?: string | null;
  style?: HTMLAttributes<HTMLImageElement>['style'];
  onClick?: MouseEventHandler<HTMLDivElement>;
}

const SVGViewer: React.FC<Props> = ({
  svg,
  alt,
  pxSize = -1,
  padding = '0',
  hexColor = null,
  style,
  onClick,
}) => {
  let size = '100%';
  if (pxSize !== -1) {
    size = `${pxSize}px`;
  }

  // optional color override filter if hexColor is provided
  const cssColorFilter = hexToCSSFilter(hexColor ?? '#000000');
  let filter = 'brightness(0) saturate(100%)'; // prefix for filter to make it black
  filter = filter + cssColorFilter.filter.replace(';', ''); // remove extra semicolon

  return (
    <img
      style={{
        width: size,
        height: size,
        padding: padding,
        filter: hexColor ? filter : 'none',
        ...style,
        cursor: onClick ? 'pointer' : undefined,
      }}
      src={svg}
      alt={alt}
      onClick={onClick}
    />
  );
};

export default SVGViewer;
